"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  shared: {
    preload: true,
    volume: 0.5
  },
  players: {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/arwes/lib/tools/createSounds/sounds.js
// module id = 253
// module chunks = 0